var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderProductViewYourFavourites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3441 15.8142C14.4357 14.7353 15.125 13.8475 16.1899 13.6369C17.7087 13.3366 20.4302 13 25 13C29.5698 13 32.2913 13.3366 33.8101 13.6369C34.875 13.8475 35.5642 14.7353 35.6559 15.8142C35.8075 17.5997 36 20.8128 36 25.6162C36 30.0574 35.9141 32.7905 35.812 34.4708C35.7169 36.035 34.52 36.5346 33.1905 35.6993L26.759 31.6583C25.6841 30.9829 24.3159 30.9829 23.241 31.6583L16.8094 35.6993C15.48 36.5346 14.2832 36.035 14.188 34.4708C14.0858 32.7905 14 30.0574 14 25.6162C14 20.8128 14.1925 17.5997 14.3441 15.8142Z",
    fill: "#9DB6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderProductViewYourFavourites);
export default __webpack_public_path__ + "static/media/HeaderProductViewYourFavourites.8eddc485d1415e7f4542b29d75ddf9c4.svg";
export { ForwardRef as ReactComponent };